<template>
    <section class="section section-shaped section-lg my-0">
        <div class="container pt-lg-md">
            <div class="row hero--header__large">
                {{ $t("jobs") }}
            </div>
        </div>
    </section>
</template>
<script>
export default {};
</script>
<style scoped>
    .hero--header__large{
        font-size: 45px;
        margin: 20px;
    }
</style>
